const KEYS = {
  OTP_DATA: 'otpData',
  LOGIN_STEP: 'loginStep',
  LOGIN_CREDENTIALS: 'loginCredentials',
};

export const otpStorage = {
  saveOtpData: (data) => {
    const expiresAt = new Date(
      Date.now() + Number(data.waitingMinutes) * 60 * 1000,
    ).getTime();

    localStorage.setItem(
      KEYS.OTP_DATA,
      JSON.stringify({
        sessionId: data.sessionId,
        waitingMinutes: data.waitingMinutes,
        expiresAt,
      }),
    );
  },

  getOtpData: () => {
    try {
      return JSON.parse(localStorage.getItem(KEYS.OTP_DATA));
    } catch {
      return null;
    }
  },

  clearOtpData: () => {
    localStorage.removeItem(KEYS.OTP_DATA);
    localStorage.removeItem(KEYS.LOGIN_STEP);
    localStorage.removeItem(KEYS.LOGIN_CREDENTIALS);
  },

  saveLoginStep: (step) => {
    if (step) {
      localStorage.setItem(KEYS.LOGIN_STEP, step);
    } else {
      localStorage.removeItem(KEYS.LOGIN_STEP);
    }
  },

  getLoginStep: () => localStorage.getItem(KEYS.LOGIN_STEP),

  saveCredentials: (credentials) => {
    localStorage.setItem(KEYS.LOGIN_CREDENTIALS, JSON.stringify(credentials));
  },

  getCredentials: () => {
    try {
      return JSON.parse(localStorage.getItem(KEYS.LOGIN_CREDENTIALS));
    } catch {
      return null;
    }
  },
};
